import { AccountRecord } from '../../api/client'
import DescriptiveToggle from '../toggles/DescriptiveToggle'
import { useAutoFetchContent } from '../toggles/AutoFetchContentToggle'

type Props = {
    account: AccountRecord
    /** What the switch does on this account's platform, from `fetchContentExplanation`. */
    explanation: string
}

/** The "Fetch with API" switch on the profile settings page, with what it does here. */
const FetchContentSetting = ({ account, explanation }: Props) => {
    const { enabled, loading, onToggle } = useAutoFetchContent(account)

    return (
        <DescriptiveToggle
            id={`fetch-content-${account.id}`}
            checked={enabled}
            onToggle={onToggle}
            label="Fetch with API"
            subtitle={explanation}
            tooltip={explanation}
            loading={loading}
            disabled={false}
        />
    )
}

export default FetchContentSetting
